<template>
  <div>
    <w-server-etc-info-view v-if="objDefineId === 'SERVER'" :data="data" />
    <w-netdevice-etc-info-view v-if="objDefineId === 'NETDEVICE' || (objDefineId === 'WIRELESS_DEVICE' && objtypeId === objtype.AP_CONTROLLER)" :data="data" />
    <w-wireless-ap-etc-info-view v-if="objDefineId === 'WIRELESS_DEVICE' && objtypeId === objtype.WIRELESS_AP" :data="data" />
    <!-- 구성 정보 변경 이력 -->
    <w-config-change-hist-view v-if="visibleConfigChangeHistView" :data="data" />
  </div>
</template>

<script>
import { isEmpty } from 'lodash';
import { objtype } from '@/constants/objtype';
import WNetdeviceEtcInfoView from './NetdeviceEtcInfoView';
import WServerEtcInfoView from './ServerEtcInfoView';
import WWirelessApEtcInfoView from './WirelessApEtcInfoView';
import WConfigChangeHistView from './ConfigChangeHistView';

export default {
  name: 'WEtcInfo',
  components: {
    WNetdeviceEtcInfoView,
    WServerEtcInfoView,
    WWirelessApEtcInfoView,
    WConfigChangeHistView,
  },
  props: {
    /**
     * 기타 분석 정보 조회 시 필요한 정보 객체 (동시성 문제 고려하여 하나의 객체로 전달)
     * 1) obj: 분석 대상 장비 정보
     * 2) eventHistData: 분석 이벤트 이력 정보
     * 3) etcInfo: 기타 분석 정보
     * @type {Object}
     */
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      objtype,
    };
  },
  computed: {
    /**
     * 분석 관리대상 정의 아이디
     * @author Ju
     * @return {String}
     */
    objDefineId() {
      return isEmpty(this.data) || isEmpty(this.data.obj) ? null : this.data.obj.objDefineId;
    },
    /**
     * 분석 관리대상 장비 구분 아이디
     * @author Ju
     * @return {String}
     */
    objtypeId() {
      return isEmpty(this.data) || isEmpty(this.data.obj) ? null : this.data.obj.objtypeId;
    },
    visibleConfigChangeHistView() {
      if (this.objDefineId === 'SERVER' || this.objDefineId === 'NETDEVICE' || this.objDefineId === 'NETINTERFACE' || this.objDefineId === 'DBMS' || this.objDefineId === 'VMS_OBJECT') {
        return !isEmpty(this.data.etcInfo) && !isEmpty(this.data.etcInfo.CONFIG_CHANGE_HIST);
      }
      return false;
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/popup/FaultAnalysisPopup/components/FaultAnalysisInfoView/EtcInfo/index.vue